import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const ReportsSchema = withDefaults({
  type: 'report',
  objectExtensions: ['report'],
  fields: [
    {
      kind: 'attribute',
      name: 'name',
    },
    {
      kind: 'attribute',
      name: 'description',
    },
    {
      kind: 'attribute',
      name: 'reportType',
    },
    {
      kind: 'attribute',
      name: 'searchConfig',
    },
    {
      kind: 'attribute',
      name: 'metadata',
    },
    {
      kind: 'attribute',
      name: 'partnerAccessConfig',
    },
    {
      kind: 'attribute',
      name: 'visibilityLevel',
    },
    {
      kind: 'attribute',
      name: 'createdBy',
    },
    {
      kind: 'attribute',
      name: 'createdAt',
    },
    {
      kind: 'attribute',
      name: 'updatedAt',
    },
    // Internal-analysis channel (tio-front-end#9772): both fields are
    // serialized by the API only for internal viewers (builder roles), so
    // they may be absent from a payload entirely.
    {
      kind: 'attribute',
      name: 'internalPublishedAt',
    },
    {
      kind: 'attribute',
      name: 'sqlBacked',
    },
  ],
});

export default ReportsSchema;
